import { newTextContent } from './TemplateUtils';
import sanitizeHTML from './sanitizeHTML';
import { ContentProps } from '../models/TopLevelTemplateComponentProps';

export function htmlToTextContent(
  html: string,
  allowNested = false,
): ContentProps | ContentProps[] | [ContentProps, ContentProps[]][] {
  const div = document.createElement('div');
  div.innerHTML = sanitizeHTML(html);

  const list = div.querySelector('ul');

  if (list) {
    if (allowNested) {
      const results: ([ContentProps, ContentProps[]] | ContentProps)[] = [];
      list.querySelectorAll<HTMLElement>(':scope > li').forEach((li) => {
        const nested = li.querySelector('ul');

        const clone = li.cloneNode(true) as HTMLElement;
        clone.querySelector('ul')?.remove();
        const text = sanitizeHTML(clone.innerHTML.trim());

        if (nested) {
          const children: ContentProps[] = [];
          nested.querySelectorAll<HTMLElement>(':scope > li').forEach((child) => {
            const childClone = child.cloneNode(true) as HTMLElement;
            childClone.querySelector('ul')?.remove();
            const t = sanitizeHTML(childClone.innerHTML.trim());
            if (t) children.push(newTextContent(t));
          });
          if (text) {
            results.push([newTextContent(text), children]);
          }
        } else if (text) {
          results.push(newTextContent(text));
        }
      });
      return results as [ContentProps, ContentProps[]][];
    }

    const texts: string[] = [];
    list.querySelectorAll('li').forEach((li) => {
      const t = sanitizeHTML((li as HTMLElement).innerHTML.trim());
      if (t) texts.push(t);
    });
    return texts.length <= 1 ? newTextContent(texts[0] || '') : texts.map((t) => newTextContent(t));
  }

  // No list — collect headings + paragraphs in document order so a heading tag's
  // text is not silently dropped; fall back to the whole fragment's text.
  const blocks = div.querySelectorAll('h1, h2, h3, h4, h5, h6, p');
  const texts: string[] = [];
  if (blocks.length > 0) {
    blocks.forEach((el) => {
      const t = sanitizeHTML((el as HTMLElement).innerHTML.trim());
      if (t) texts.push(t);
    });
  } else {
    const t = sanitizeHTML(div.innerHTML.trim());
    if (t) texts.push(t);
  }

  // Plain prose stays ONE node (paragraphs joined by <br><br>). An array renders
  // as a <ul>, so multiple paragraph nodes would show as an unwanted bullet list.
  return newTextContent(texts.join('<br><br>'));
}
